import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { sspEasyConfig, sspEasyConfigUrls } from 'src/environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-ssp-easy',
    template: ''
})
export class SspEasyComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    const currentParams = this.route.snapshot.queryParams;

    if (window.location.href.includes('easy-ssp/amlForm')) {
      const newParams = { formName: 'amlForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/loanConfirmationForm')) {
      const newParams = { formName: 'loanConfirmationForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/deferralForm')) {
      const newParams = { formName: 'deferralForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/changeDebitDateForm')) {
      const newParams = { formName: 'changeDebitDateForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (
      window.location.href.includes('easy-ssp/changeDebitAccountForm')
    ) {
      const newParams = { formName: 'changeDebitAccountForm' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/ca-confirmation')) {
      const newParams = { formName: 'ca-confirmation' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/debit-reduction')) {
      const newParams = { formName: 'debit-reduction' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/product-confirmation')) {
      const newParams = { formName: 'product-confirmation' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/chatbot-ticket')) {
      const newParams = { formName: 'chatbot-ticket' };
      const mergedParams = { ...currentParams, ...newParams };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/secured-id-update')) {
      const newParams = { formName: 'secured-id-update' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/secured-rp-update')) {
      const newParams = { formName: 'secured-rp-update' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    } else if (window.location.href.includes('easy-ssp/personal-data-change')) {
      const newParams = { formName: 'personal-data-change' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
      else if (window.location.href.includes('easy-ssp/cashless-payment')) {
      const newParams = { formName: 'cashless-payment' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
     else if (window.location.href.includes('easy-ssp/cashless-salary-payment')) {
      const newParams = { formName: 'cashless-salary-payment' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
     else if (window.location.href.includes('easy-ssp/cashless-pension-payment')) {
      const newParams = { formName: 'cashless-pension-payment' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
    else if (window.location.href.includes('easy-ssp/second-owner-invite')) {
      const newParams = { formName: 'second-owner-invite' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }
    else if (window.location.href.includes('easy-ssp/ticket-status-check')) {
      const newParams = { formName: 'ticket-status-check' };
      const mergedParams = { ...currentParams, ...newParams };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: mergedParams,
        queryParamsHandling: 'merge',
      });
    }

    const buildUrl = (
      baseUrl: string,
      queryParams: { [key: string]: string | undefined }
    ) => {
      const resolvedQueryParams = { ...queryParams };
      const id = this.route.snapshot.queryParams['id'];

      if (
        id !== undefined &&
        id !== '' &&
        (resolvedQueryParams['id'] === undefined || resolvedQueryParams['id'] === '')
      ) {
        resolvedQueryParams['id'] = id;
      }

      const queryString = Object.entries(resolvedQueryParams)
        .filter(([_, value]) => value !== undefined && value !== '')
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      if (!queryString) {
        return baseUrl;
      }

      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}${queryString}`;
    };

    this.route.queryParams.subscribe(async (params) => {
      const formName = params['formName'];
      const inApp = params['inApp'];
      const lang = params['lang'];
      const tenant = params['tenanthost'];
      const productIdentifier = params['product_identifier'];
      const changeType = params['changeType'];
      const ticketNumber = params['ticketNumber'];

      switch (formName) {
        case 'amlForm':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(sspEasyConfigUrls.amlFormUrl, {
              ebanking: 'true',
              lang,
              product_identifier: productIdentifier,
            });
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(sspEasyConfigUrls.amlFormUrl, {
              inApp: 'true',
              lang,
              product_identifier: productIdentifier,
            });
          } else {
            sspEasyConfig.redirectUri = sspEasyConfigUrls.amlFormUrl;
          }
          break;
        case 'loanConfirmationForm':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.loanConfirmationFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.loanConfirmationFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri =
              sspEasyConfigUrls.loanConfirmationFormUrl;
          }
          break;
        case 'deferralForm':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.loanDeferralFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.loanDeferralFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri = sspEasyConfigUrls.loanDeferralFormUrl;
          }
          break;
        case 'changeDebitDateForm':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.changeDebitDateForm,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.changeDebitDateForm,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri = sspEasyConfigUrls.changeDebitDateForm;
          }
          break;
        case 'changeDebitAccountForm':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.changeDebitAccountForm,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.changeDebitAccountForm,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri =
              sspEasyConfigUrls.changeDebitAccountForm;
          }
          break;
        case 'ca-confirmation':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.currentAccountFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.currentAccountFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri = sspEasyConfigUrls.currentAccountFormUrl;
          }
          break;
        case 'debit-reduction':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.debitReductionFormUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.debitReductionFormUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri = sspEasyConfigUrls.debitReductionFormUrl;
          }
          break;
        case 'product-confirmation':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.productConfirmationUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.productConfirmationUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri =
              sspEasyConfigUrls.productConfirmationUrl;
          }
          break;
        case 'chatbot-ticket':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.chatbotTicketUrl,
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.chatbotTicketUrl,
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
              }
            );
          } else {
            sspEasyConfig.redirectUri = sspEasyConfigUrls.chatbotTicketUrl;
          }
          break;
        case 'ticket-status-check':
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.disTicketStatusUrl,
              { ebanking: 'true', lang, ticketNumber }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.disTicketStatusUrl,
              { inApp: 'true', lang, ticketNumber }
            );
          } else {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls.disTicketStatusUrl,
              { ticketNumber }
            );
          }
          break;

          case 'cashless-payment':
                   if (tenant === 'eb') {
                     sspEasyConfig.redirectUri = buildUrl(
                       sspEasyConfigUrls.cashlessPaymentUrl,
                       {
                         ebanking: 'true',
                         lang,
                         product_identifier: productIdentifier,
                       }
                     );
                   } else if (inApp === 'true') {
                     sspEasyConfig.redirectUri = buildUrl(
                       sspEasyConfigUrls.cashlessPaymentUrl,
                       {
                         inApp: 'true',
                         lang,
                         product_identifier: productIdentifier,
                       }
                     );
                   } else {
                     sspEasyConfig.redirectUri = sspEasyConfigUrls.cashlessPaymentUrl;
                   }
                 break;
                  case 'cashless-salary-payment':
                   if (tenant === 'eb') {
                     sspEasyConfig.redirectUri = buildUrl(
                       sspEasyConfigUrls.cashlessSalaryPaymentUrl,
                       {
                         ebanking: 'true',
                         lang,
                         product_identifier: productIdentifier,
                       }
                     );
                   } else if (inApp === 'true') {
                     sspEasyConfig.redirectUri = buildUrl(
                       sspEasyConfigUrls.cashlessSalaryPaymentUrl,
                       {
                         inApp: 'true',
                         lang,
                         product_identifier: productIdentifier,
                       }
                     );
                   } else {
                     sspEasyConfig.redirectUri = sspEasyConfigUrls.cashlessSalaryPaymentUrl;
                   }
                 break;
                  case 'cashless-pension-payment':
                   if (tenant === 'eb') {
                     sspEasyConfig.redirectUri = buildUrl(
                       sspEasyConfigUrls.cashlessPensionPaymentUrl,
                       {
                         ebanking: 'true',
                         lang,
                         product_identifier: productIdentifier,
                       }
                     );
                   } else if (inApp === 'true') {
                     sspEasyConfig.redirectUri = buildUrl(
                       sspEasyConfigUrls.cashlessPensionPaymentUrl,
                       {
                         inApp: 'true',
                         lang,
                         product_identifier: productIdentifier,
                       }
                     );
                   } else {
                     sspEasyConfig.redirectUri = sspEasyConfigUrls.cashlessPensionPaymentUrl;
                   }
                 break;
        default:
          // applicable only for new generic forms (DEM1521-7506, DEM1521-7843)
          const formUrl = formName.includes('-')
            ? formName.replace(/-./g, (match: string) =>
                match.charAt(1).toUpperCase()
              ) + 'Url'
            : formName + 'Url';
          if (tenant === 'eb') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls[formUrl as keyof typeof sspEasyConfigUrls],
              {
                ebanking: 'true',
                lang,
                product_identifier: productIdentifier,
                changeType,
              }
            );
          } else if (inApp === 'true') {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls[formUrl as keyof typeof sspEasyConfigUrls],
              {
                inApp: 'true',
                lang,
                product_identifier: productIdentifier,
                changeType,
              }
            );
          } else {
            sspEasyConfig.redirectUri = buildUrl(
              sspEasyConfigUrls[formUrl as keyof typeof sspEasyConfigUrls],
              {
                changeType,
              }
            );
          }
          break;
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(sspEasyConfig);
  }
}